module.exports = __webpack_public_path__ + "static/image/company/m/image_sustainable_policy@3x.ver2_0_2.jpg?20d3b0f1";